import { useState, useEffect, useRef } from "react"
import { useLocation, Link } from "react-router-dom"

import "./login.css"
import "../register/register.css"

import logo from "../../assets/general_assets/Transparent logo.png"

export default function Login() {

    const logIn = useRef(null);
    const signIn = useRef(null);

    const location = useLocation();

    useEffect(() => {
        if (location.pathname === "/login" && !(signIn?.current.classList.contains('nonPage'))) {
            signIn?.current.classList.add('nonPage');   
            logIn?.current.classList.remove('nonPage')
            
        }
    })

    return (
        <>

            <section className="register_screen">
                <img id="registerLogo1" src={logo}/>
                <img id="registerLogo2" src={logo}/>

                <div className="register_box login">
                    <h2>Welcome Back!</h2>
                    <div className="sign_log_box login">
                        <Link to="/register"><h3 ref={signIn} id="signInTab">Sign in</h3></Link>
                        <Link to="/login"><h3 ref={logIn} id="logInTab">Log in</h3></Link>
                    </div>
                    <form id="LogIn" className="register_form login">
                        <input className="login"
                            placeholder="email"
                            type="text"
                            name="email"
                            required
                            
                        />
                        <input className="login"
                            placeholder="password"
                            type="password"
                            name="password" 
                            required
                            
                            />
                        
                    <button type="submit" className="register_button">
                        Log in
                    </button>
                    </form>
                </div>
            </section>
        
        </>
    )


} 
